import { createAuthApi } from '@modeling/account';
import { resolveEmagentApiBaseUrl } from './env';

export const emagentApi = createAuthApi(resolveEmagentApiBaseUrl());
